import React, { useState, useEffect } from "react";
import { opcionesAPI, type Deposito, depositoSucursalesLabel } from "@/lib/api";
import { toast } from "sonner";
import { ListNewLoading, ListToolbar } from "@/components/ListNewButton";

interface Props {
  onEdit?: (item: Deposito) => void;
  onNew?: () => void;
}

export function DepositosListado({ onEdit, onNew }: Props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [depositos, setDepositos] = useState<Deposito[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await opcionesAPI.listDepositos();
        setDepositos(data);
      } catch (error) {
        console.error("Error loading depositos:", error);
        toast.error("Error al cargar depósitos");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredDepositos = depositos.filter(d =>
    !searchQuery ||
    d.codigo?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    d.nombre?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return <ListNewLoading onNew={onNew} message="Cargando depósitos..." />;
  }

  return (
    <div className="space-y-4 mt-4">
      <ListToolbar onNew={onNew}>
        <label className="block text-sm font-medium mb-1">Buscar</label>
        <input
          type="text"
          placeholder="Buscar por cualquier campo..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full px-4 py-2 border border-input bg-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-sm"
        />
      </ListToolbar>

      {filteredDepositos.length === 0 ? (
        <div className="p-8 text-center text-muted-foreground">
          No se encontraron depósitos
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted">
              <tr>
                <th className="px-4 py-2 text-left">Código</th>
                <th className="px-4 py-2 text-left">Nombre</th>
                <th className="px-4 py-2 text-left">Sucursales</th>
              </tr>
            </thead>
            <tbody>
              {filteredDepositos.map((deposito) => (
                <tr
                  key={deposito.codigo}
                  className="border-b hover:bg-muted/50 cursor-pointer"
                  onClick={() => onEdit?.(deposito)}
                >
                  <td className="px-4 py-2">{deposito.codigo}</td>
                  <td className="px-4 py-2">{deposito.nombre}</td>
                  <td className="px-4 py-2">{depositoSucursalesLabel(deposito)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}